import { LoadingButton } from "@mui/lab";
import { Box, Divider, TextField } from "@mui/material";
import { ChangeEvent, useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { NoteDto, NoteService } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import { SnackbarContext } from "../../../contexts/SnackbarContext";
import { addOrUpdateNoteAction } from "../../../slices/SharedActions";

// updated
export default function UpsertNoteDialog(props: {
    projectHashId: string;
    note?: NoteDto;
}) {
    const dispatch = useDispatch();

    const [notes, setNotes] = useState<string>(props.note?.content ?? "");
    const [requestInProgress, setRequestInProgress] = useState<boolean>(false);

    const { closeDialog } = useContext(DialogContext);
    const { showSnackbar } = useContext(SnackbarContext);

    const handleNotesChange = (event: ChangeEvent<HTMLInputElement>) => {
        setNotes(event.target.value);
    };

    const postNote = () => {
        setRequestInProgress(true);

        const request = props.note
            ? NoteService.updateNote(props.note.id, "1", {
                  content: notes,
              })
            : NoteService.addNote("1", {
                  content: notes,
                  projectHashId: props.projectHashId,
              });

        request
            .then((n) => {
                dispatch(addOrUpdateNoteAction(n));
                closeDialog();
                showSnackbar("تغییرات یادداشت ذخیره شد", "success");
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    return (
        <DialogContainer>
            <DialogHeader title="افزودن / ویرایش یادداشت" />

            <Box sx={{ p: 2 }}>
                <TextField
                    value={notes}
                    fullWidth
                    label="متن یادداشت"
                    multiline
                    onChange={handleNotesChange}
                    rows={3}
                    maxRows={6}
                />

                <Divider sx={{ my: 2 }} />

                <LoadingButton
                    onClick={postNote}
                    variant="contained"
                    loading={requestInProgress}
                >
                    ذخیره یادداشت
                </LoadingButton>
            </Box>
        </DialogContainer>
    );
}
